export const RELATED_FETCH = 'Ui/AssetForm/RELATED_FETCH';
export const RELATED_FETCH_SUCCESS = 'Ui/AssetForm/RELATED_FETCH_SUCCESS';
export const RELATED_FETCH_ERROR = 'Ui/AssetForm/RELATED_FETCH_ERROR';

export const NEXT_SEARCH = 'Ui/AssetForm/NEXT_SEARCH';
export const NEXT_SEARCH_SUCCESS = 'Ui/AssetForm/NEXT_SEARCH_SUCCESS';
export const NEXT_SEARCH_ERROR = 'Ui/AssetForm/NEXT_SEARCH_ERROR';
